var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDowngray2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.03975 8.97725C5.25942 8.75758 5.61558 8.75758 5.83525 8.97725L12 15.142L18.1648 8.97725C18.3844 8.75758 18.7406 8.75758 18.9602 8.97725C19.1799 9.19692 19.1799 9.55308 18.9602 9.77275L12.3977 16.3352C12.1781 16.5549 11.8219 16.5549 11.6023 16.3352L5.03975 9.77275C4.82008 9.55308 4.82008 9.19692 5.03975 8.97725Z",
    fill: "#858479"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDowngray2);
export default __webpack_public_path__ + "static/media/downgray2.c4e9787513292fef71936810e6d4e0a5.svg";
export { ForwardRef as ReactComponent };